<template>
  <v-app>
    <v-app-bar dark color="#3949AB" app></v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-card
          class="mx-auto"
          min-width="100%"
          min-height="100%"
          outlined
          elevation="5"
        >
          <v-card-title primary-title class="justify-center">
            初回ログイン({{ titleText }}登録)
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <v-row class="text-center" justify="center">
              <v-stepper v-model="rabNo" min-width="100%" class="no-shadow">
                <v-stepper-items>
                  <!-- メールアドレス登録　-->
                  <v-stepper-content step="1">
                    <v-form v-model="valid1" ref="form1" lazy-validation>
                      <v-alert
                        v-if="error != ''"
                        style="white-space: pre-line"
                        color="red"
                        text
                        >{{ this.error }}</v-alert
                      >
                      <v-alert v-if="message != ''" color="blue" text>{{
                        this.message
                      }}</v-alert>
                      <v-col cols="50">
                        <v-text-field
                          label="ユーザID"
                          v-model="username"
                          :counter="10"
                          maxlength="10"
                          :rules="[GlobalRules.required, GlobalRules.hanAlpha]"
                          required
                          :disabled="mailCodeSend"
                          prepend-icon="mdi-account-circle"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="50">
                        <v-text-field
                          label="新しいメールアドレス"
                          v-model="email"
                          :counter="64"
                          :rules="[GlobalRules.required, GlobalRules.email]"
                          required
                          :disabled="mailCodeSend"
                          prepend-icon="mdi-email"
                        ></v-text-field>
                      </v-col>
                    </v-form>
                    <!-- 2024.12.12 kouta.noborisaka 三井化学（市原工場）:Enterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
                    <v-form
                      v-model="valid2"
                      ref="form2"
                      lazy-validation
                      @submit.prevent
                    >
                      <v-col cols="50" v-if="mailCodeSend">
                        <v-text-field
                          label="認証コード"
                          v-model="mailAuthCode"
                          :counter="6"
                          maxlength="6"
                          :rules="[GlobalRules.required, GlobalRules.authcode]"
                          required
                          prepend-icon="mdi-account-check"
                        ></v-text-field>
                      </v-col>
                    </v-form>
                    <v-card-actions>
                      <v-btn
                        color="blue"
                        outlined
                        block
                        :disabled="!valid1"
                        v-if="!mailCodeSend"
                        @click="signUp(username, email)"
                        >認証コード送信</v-btn
                      >
                      <v-btn
                        color="blue"
                        outlined
                        block
                        :disabled="!valid1 || !valid2"
                        v-if="mailCodeSend"
                        @click="confirmEmail(username, mailAuthCode)"
                        >登録</v-btn
                      >
                    </v-card-actions>
                    <div class="pt-8 pb-4" v-if="showSigninLink">
                      <router-link :to="{ name: 'Signin' }"
                        >ログイン画面</router-link
                      >
                    </div>
                  </v-stepper-content>
                  <!-- パスワード登録　-->
                  <v-stepper-content step="2">
                    <v-form v-model="valid3" ref="form3" lazy-validation>
                      <v-alert
                        v-if="error != ''"
                        color="red"
                        style="white-space: pre-line"
                        text
                        >{{ this.error }}</v-alert
                      >
                      <v-alert v-if="message != ''" color="blue" text>{{
                        this.message
                      }}</v-alert>
                      <v-col cols="50">
                        <v-text-field
                          label="ユーザID"
                          v-model="username"
                          :counter="10"
                          maxlength="10"
                          :rules="[GlobalRules.required, GlobalRules.hanAlpha]"
                          disabled
                          prepend-icon="mdi-account-circle"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="50" v-if="passCodeSend">
                        <v-text-field
                          label="認証コード"
                          v-model="passAuthCode"
                          :counter="6"
                          maxlength="6"
                          :rules="[GlobalRules.required, GlobalRules.authcode]"
                          required
                          prepend-icon="mdi-account-check"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="50" v-if="passCodeSend"> </v-col>
                      <v-col cols="50" v-if="passCodeSend">
                        8文字以上、英字（大小）、数字、記号（_?!#$%&）を含めて設定必須
                      </v-col>
                      <v-col cols="50" v-if="passCodeSend">
                        <v-text-field
                          label="新しいパスワード"
                          v-model="password"
                          :counter="20"
                          maxlength="20"
                          :rules="[
                            GlobalRules.required,
                            GlobalRules.hanSpec,
                            GlobalRules.more_8,
                            GlobalRules.required_lowercase,
                            GlobalRules.required_uppercase,
                            GlobalRules.required_number,
                            GlobalRules.required_spec,
                          ]"
                          required
                          v-bind:type="showPassword ? 'text' : 'password'"
                          v-bind:append-icon="
                            showPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          prepend-icon="mdi-lock"
                          @click:append="showPassword = !showPassword"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="50" v-if="passCodeSend">
                        <v-text-field
                          label="パスワード確認"
                          v-model="confPassword"
                          :counter="20"
                          maxlength="20"
                          :rules="[
                            GlobalRules.required,
                            GlobalRules.hanSpec,
                            GlobalRules.more_8,
                            GlobalRules.required_lowercase,
                            GlobalRules.required_uppercase,
                            GlobalRules.required_number,
                            GlobalRules.required_spec,
                          ]"
                          required
                          v-bind:type="showConfPassword ? 'text' : 'password'"
                          v-bind:append-icon="
                            showConfPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          prepend-icon="mdi-lock"
                          @click:append="showConfPassword = !showConfPassword"
                        ></v-text-field>
                      </v-col>
                      <v-card-actions>
                        <v-btn
                          color="blue"
                          outlined
                          block
                          v-if="!passCodeSend"
                          @click="resetPass(username)"
                          >認証コード送信</v-btn
                        >
                        <v-btn
                          color="blue"
                          outlined
                          block
                          :disabled="!valid3"
                          v-if="passCodeSend"
                          @click="
                            registerPass(
                              username,
                              password,
                              confPassword,
                              passAuthCode
                            )
                          "
                          >登録</v-btn
                        >
                      </v-card-actions>
                      <div class="pt-8 pb-4" v-if="showSigninLink">
                        <router-link :to="{ name: 'Signin' }"
                          >ログイン画面</router-link
                        >
                      </div>
                    </v-form>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <v-footer dark color="#3949AB" style="height: 3%" app></v-footer>
  </v-app>
</template>

<script>
export default {
  name: "InitialSignin",

  data: () => ({
    password: "",
    confPassword: "",
    showPassword: false,
    showConfPassword: false,
    valid1: false,
    valid2: false,
    valid3: false,
    error: "",
    mailCodeSend: false,
    passCodeSend: false,
    mailAuthCode: "",
    passAuthCode: "",
    username: "",
    email: "",
    rabNo: 1,
    titleText: "メールアドレス",
    showSigninLink: true,
    message: "",
    url: {
      get: "/initialSignin/checkUserClassDomitory",
      update: "/initialSignin/updateMailAddress",
    },
  }),

  methods: {
    /** 寮生確認 */
    async checkUserClassDomitory(userId) {
      var result = false;
      // パラメータ設定
      var queryUrl = this.url.get + "/" + userId;
      // 寮生確認
      await this.getRequest(queryUrl, null, null).then((resp) => {
        result = resp.result;
      });
      return result;
    },
    /** メールアドレス更新 */
    async updateMailAddress(userId, mailAddress) {
      var result = false;
      // パラメータ設定
      var params = {
        userId: userId,
        mailAddress: mailAddress,
      };
      // メールアドレス更新
      await this.putRequest(this.url.update, params, null).then((resp) => {
        result = resp.result;
      });
      return result;
    },
    /** サインアップ */
    async signUp(userId, email) {
      if (!this.$refs.form1.validate()) {
        return;
      }
      // 寮生確認処理を実施
      var res = await this.checkUserClassDomitory(userId);
      if (res == "1") {
        // ユーザ情報が取得できない場合
        this.message = "";
        this.error = "対象のユーザIDは存在していません。";
        return;
      } else if (res == "2") {
        // 寮生以外の場合エラー終了とする。
        this.message = "";
        this.error = "寮生以外はログイン画面よりログインしてください。";
        return;
      }

      this.$cognito
        .selfSignUp(userId, email)
        .then(async () => {
          this.mailCodeSend = true;
          this.error = "";
          this.showSigninLink = false;
          this.message = "認証コードを送信しました。";
          var mailResult = await this.updateMailAddress(userId, email);
          if (mailResult) {
            this.error = "";
          } else {
            this.error =
              "ログイン後に「通知先メール変更」画面にて、メールアドレスを再設定してください。";
          }
        })
        .catch((err) => {
          this.showErrorMessage(err, "送信");
        });
    },
    /** 連絡先検証 */
    confirmEmail(userId, authCode) {
      if (!this.$refs.form1.validate() || !this.$refs.form2.validate()) {
        return;
      }
      this.$cognito
        .mailConfirm(userId, authCode)
        .then(() => {
          this.rabNo = 2;
          this.titleText = "パスワード";
          this.error = "";
          this.message = "";
        })
        .catch((err) => {
          this.showErrorMessage(err, "登録");
        });
    },
    /** パスワードリセット */
    resetPass(userId) {
      this.$cognito
        .forgetPassword(userId)
        .then(() => {
          this.passCodeSend = true;
          this.error = "";
          this.message = "認証コードを送信しました。";
        })
        .catch((err) => {
          this.showErrorMessage(err, "送信");
        });
    },
    /** パスワード登録 */
    registerPass(userId, password, confPassword, authCode) {
      if (!this.$refs.form3.validate()) {
        return;
      }
      if (password == confPassword) {
        this.$cognito
          .resetPassword(userId, password, authCode)
          .then((result) => {
            //eslint-disable-line
            this.showSigninLink = true;
            this.error = "";
            this.message =
              "登録が完了しました。\n3秒後に自動でログイン画面に遷移します。";
            setTimeout(() => {
              this.$router.push("/");
            }, 3000);
          })
          .catch((err) => {
            this.showErrorMessage(err, "登録");
          });
      } else {
        this.message = "";
        this.error = "パスワードの入力内容を確認してください。";
      }
    },
    /** エラーメッセージを表示する */
    showErrorMessage(err, param) {
      this.message = "";
      if (err.code == "NetworkError") {
        this.error = "ネットワークに接続してください。";
      } else if (err.code == "LimitExceededException") {
        this.error = "しばらく時間をあけてください。";
      } else if (err.code == "CodeMismatchException") {
        this.error = "認証コードに誤りがあります。";
      } else if (err.code == "UsernameExistsException") {
        this.error =
          "ログイン画面よりログインしてください。\nログインできない場合は管理人までお問合せください。";
      } else {
        this.error = param + "できませんでした。入力内容を確認してください。";
      }
    },
  },
};
</script>
<style scoped>
.no-shadow {
  box-shadow: none !important;
}
</style>
